<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_vii"></a><a id="fm002"></a><strong>It is not revolutions and upheavals<br/>That clear the road to new and better days,<br/>But revelations, lavishness and torments<br/>Of someone’s soul, inspired and ablaze.</strong></p>
<p class="noindent"><strong>Boris Pasternak, “After the Storm,” 1958</strong></p>
<p class="image"><a id="page_viii"></a><img alt="Image" src="images/f00ix-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm002.vue?3c64a2b4